/* 
 * inherits from joint.shapes.html.QuestionBoxView
 * (which must have been declared before calling this constructor) 
 */
export function RootQuestionBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.QuestionBoxView.extend({
    template: [
      '<div class="html-element">',
      '  <div class="question-media-content">',
      '    <img src="" width="100%">',
      '    <video preload="" controls="" src="" width="100%" style="pointer-events: auto;"></video>',
      '  </div>',
      '  <div class="question-text-content-container">',
      '    <div class="question-text-content"></div>',
      '    <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>',
      '  </div>',
      '  <div class="error-messages-container">',
      '    <div class="all-descriptions-or-none-message invalid-message ng-hide">',
             services.$translate.instant('parameters/quick_replies/internal_errors/3'),
      '    </div>',
      '  </div>',
      '  <button class="add-answer center-block btn btn-alcmeon-default">',
          services.$translate.instant('parameters/quick_replies/details/add_an_answer'),
      '  </button>',
      '</div>'
    ].join(''),

    initialize: function() {
      this.model.set("canBeDuplicated", false); // Filter the box dropdown items
      this.model.set("canBeDeleted", false);

      joint.shapes.html.QuestionBoxView.prototype.initialize.apply(this, arguments);
    }
  });
}